import { render, staticRenderFns } from "./FilterBeds.vue?vue&type=template&id=4c043018&"
import script from "./FilterBeds.vue?vue&type=script&lang=js&"
export * from "./FilterBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports